import { FC } from 'react'
import { useLocation } from 'react-router-dom'

import { ButtonPromo, TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { Space } from 'components/ui/Space/Space'
import { sendAdriverEvent } from 'utils/adriver/sendAdriverEvent'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { docs } from 'shared/constants/docs'
import { PromoGeRoutesEnum } from 'shared/constants/routes'
import { SCROLL_TO_ID } from 'shared/constants/values'
import { AdriverEventType, EventType } from 'types/types'

import { LazyLoadVideo } from './components/LazyLoadVideo'

import s from './VideoSection.module.scss'

interface VideoSectionProps {
  title: string
  description: string
  videoSrc: string
  poster: string
  useIframe: boolean
}

export const VideoSection: FC<VideoSectionProps> = ({ title, description, videoSrc, poster, useIframe }) => {
  const { isTablet, isMobile } = useResize()
  const location = useLocation()

  const isHomePage = location.pathname === PromoGeRoutesEnum.root

  return (
    <section className={s.section}>
      <div className={`contentWrapper ${s.videoSection}`}>
        <div className={s.title}>
          <Space size={!isMobile ? 140 : 80} />
          <TextPromo
            id={SCROLL_TO_ID.videoSection}
            size={isTablet ? (isMobile ? 's32' : 's40') : 's70'}
            center
            weight="w700"
          >
            {title}
          </TextPromo>

          <Space size={24} />
          <TextPromo
            center={isTablet}
            fontFamily="ASLHauss"
            size={isTablet ? (isMobile ? 's16' : 's20') : 's20'}
            color="gray"
          >
            {description}
          </TextPromo>
        </div>

        <Space size={isTablet ? (isMobile ? 24 : 40) : 64} />
        <LazyLoadVideo className={s.videoFrame} src={videoSrc} poster={poster} useIframe={useIframe} />
        {isHomePage && (
          <>
            <ButtonPromo className={s.button} fullWidth={isTablet}>
              <Href
                href={docs.checklist}
                type="text"
                className={s.link}
                linkType="search"
                target="_blank"
                onClick={() => {
                  sendEvent(EventType.ChecklistDnl)
                  sendAdriverEvent(AdriverEventType.downloadChecklist)
                }}
              >
                Скачать чек-лист по открытию ПВЗ
              </Href>
            </ButtonPromo>
          </>
        )}
      </div>
    </section>
  )
}

export default VideoSection
